import { render, staticRenderFns } from "./Gradient.vue?vue&type=template&id=5539a195&scoped=true&"
import script from "./Gradient.vue?vue&type=script&lang=js&"
export * from "./Gradient.vue?vue&type=script&lang=js&"
import style0 from "./Gradient.vue?vue&type=style&index=0&id=5539a195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539a195",
  null
  
)

export default component.exports